import React from 'react';
import { Box } from '@mui/material';

function ListItemsBlock({ id, type, properties }) {
  const listType = properties.listType || 'ul';
  const items = properties.items || [];
  const listStyleType = properties.listStyleType || (listType === 'ul' ? 'disc' : 'decimal');

  const listStyles = {
    padding: `${properties.padding.top}px ${properties.padding.right}px ${properties.padding.bottom}px ${properties.padding.left}px`,
    margin: `${properties.margin.top}px ${properties.margin.right}px ${properties.margin.bottom}px ${properties.margin.left}px`,
    backgroundColor: properties.backgroundColor || 'transparent',
  };

  const listElementStyles = {
    listStyleType: listStyleType,
    paddingLeft: '20px',
    margin: 0,
    fontSize: `${properties.fontSize || 16}px`,
    fontFamily: properties.fontFamily || 'Arial, sans-serif',
    fontWeight: properties.fontWeight || 'normal',
    color: properties.color || '#000000',
    textAlign: properties.textAlign || 'left',
    lineHeight: properties.lineHeight || 1.5,
  };

  const listItemStyles = {
    marginBottom: `${properties.itemSpacing || 8}px`,
    color: properties.color || '#000000',
  };

  const markerStyles = {
    color: properties.markerColor || '#000000',
  };

  return (
    <Box sx={listStyles}>
      <Box
        component={listType}
        sx={{
          ...listElementStyles,
          '& li::marker': markerStyles,
        }}
      >
        {items.map((item, index) => (
          <Box
            component="li"
            key={index}
            sx={listItemStyles}
          >
            {item}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default ListItemsBlock;
